import { createElement, styled, space, background, border, borderBottom, borderTop, borderRight, borderLeft, borderColor } from '@vebox/etui-system';

const TrElement = createElement('tr');
const Tr = styled(TrElement)`
  ${space};
  ${background};
  ${border};
  ${borderBottom};
  ${borderTop};
  ${borderRight};
  ${borderLeft};
  ${borderColor};
`;

export { Tr };
